export default "__VITE_ASSET__CZn8YeH8__"